"use client";
import Card from "@/components/primitives/card";
import Table from "@/components/primitives/table";
import Tabs, { TabItem } from "@/components/primitives/tabs";
import TeamLogo from "@/components/team/logo";
import { RecentGames, RecentGamesNew, Sport, TeamBasic, createServerSeason } from "common";
import React from "react";
import RecentGamesTable from "./recent-games-table";
import RecentGamesMetrics from "./recent-games-metrics";
import useFetch from "@/utils/fetch";
import NotFound from "@/components/primitives/not-found";
import { LoadingCircle } from "@/components/primitives/loading";

export default function RecentGamesCard({
    sport,
  awayTeam,
  homeTeam,
}: {
    sport: Sport;
  awayTeam: TeamBasic;
  homeTeam: TeamBasic;
}) {
  const [view, setView] = React.useState<string>("h2h");
  const base_url: string = `${process.env.NEXT_PUBLIC_API_URL}/api/sports/${sport}/recent-games/`;
  const params: URLSearchParams = new URLSearchParams;
  params.append("homeKey", homeTeam.abbreviation);
  params.append("awayKey", awayTeam.abbreviation);
  // params.append("season", "2023REG");
  const request: string = `${base_url}?${params}`;
  const { data, isLoading, isError, error } = useFetch<RecentGamesNew | null>(
    null,
    request,
    []
  );
  // console.log("recent games req: ", request);
  // console.log(data);
  // console.log(view);

  const items: TabItem[] = [
    {
        label: <span className="whitespace-nowrap">Head-To-Head</span>,
        value: "h2h",
    },
    {
      label: (
        <div className="flex items-center max-h-[20px] gap-2">
          <TeamLogo team={awayTeam} size="sm" /> <span>{awayTeam.abbreviation}</span>
        </div>
      ),
      value: "away",
    },
    {
      label: (
        <div className="flex items-center max-h-[20px] gap-2">
          <TeamLogo team={homeTeam} size="sm" /> <span>{homeTeam.abbreviation}</span>
        </div>
      ),
      value: "home",
    },
  ];
  if (data) {
    return (
      <Card
      className="!pt-4"
        header={{
          title: (
            <>
              <span>Recent Games</span>
              <div className="w-px h-4 bg-surface-500"></div>
              <span className="text-base text-secondary normal-case">
                Last 10
              </span>
            </>
          ),
          action: (
            <div className="overflow-x-auto">
              <Tabs
                variant="pill"
                label="Recent Games Filters"
                value={view}
                items={items}
                onValueChange={(v) => setView(v)}
              />
            </div>
          ),
        }}
      >
        <RecentGamesMetrics data={data} view={view} sport={sport}/>
        <RecentGamesTable data={data} view={view} />
      </Card>
    );
  }
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-[220px]">
        <LoadingCircle />
      </div>
    );
  }
  if (!isLoading && !data) {
    return <NotFound label="No Recent Games" icon="target-miss" />;
  }
}
